import React from 'react';
import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useNewProjectUrl } from 'domain/shared/newProject';
import ProjectBreadcrumbs from './ProjectFinanceBreadcrumbs';
import { useParams } from 'react-router-dom';

const AssumptionBreadcrumbs = ({ children = null }: { children?: React.ReactNode | React.ReactNode[] | null }) => {
  const { getAssumptionsUrl } = useNewProjectUrl();
  const { id } = useParams();

  return (
    <ProjectBreadcrumbs>
      <ListBreadcrumbItem entity="Assumption" link={getAssumptionsUrl(id!)} />
      {children}
    </ProjectBreadcrumbs>
  );
};

export default AssumptionBreadcrumbs;
